var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

// src/components/contact-us/contact-us-form.tsx
import React23, { useCallback as useCallback3, useState as useState4 } from "react";
import { flushSync } from "react-dom";

// ../internal/src/components/view/sheet-view-port.tsx
import React from "react";
import { EGDSSheet } from "@egds/react-core/sheet";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var SheetViewPort = _a => {
  var _b = _a,
    {
      children
    } = _b,
    props = __objRest(_b, ["children"]);
  return /* @__PURE__ */React.createElement(Viewport, null, /* @__PURE__ */React.createElement(ViewSmall, null, /* @__PURE__ */React.createElement(EGDSSheet, __spreadProps(__spreadValues({}, props), {
    type: "full"
  }), children)), /* @__PURE__ */React.createElement(ViewLarge, null, /* @__PURE__ */React.createElement(EGDSSheet, __spreadProps(__spreadValues({}, props), {
    type: "centered"
  }), children)));
};

// src/components/contact-us/__private/__fragments/contact-us-email-us-form-view.tsx
import React14, { useState as useState2 } from "react";
import { EGDSForm } from "@egds/react-core/form";
import { EGDSLayoutFlex as EGDSLayoutFlex4 } from "@egds/react-core/layout-flex";
import { EGDSSheetContent } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing5, EGDSSpacingHr } from "@egds/react-core/spacing";
import { gql as gql10, useQuery } from "@shared-ui/apollo-client-wrapper";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents2 } from "@shared-ui/logger-context";

// ../internal/src/components/contact-us-tool-bar/contact-us-tool-bar.tsx
import React2 from "react";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { gql } from "@shared-ui/apollo-client-wrapper";
var fragment = gql`
  fragment ContactUsToolBarFragment on ContactUsToolBar {
    title
    icon {
      id
    }
    navIconLabel
  }
`;
var ContactUsToolBar = props => {
  var _a;
  const {
    close,
    data
  } = props;
  return /* @__PURE__ */React2.createElement(EGDSToolbar, {
    navigationContent: {
      onClick: close,
      navIconLabel: (_a = data.navIconLabel) != null ? _a : void 0,
      navButtonId: data.icon.id
    },
    toolbarTitle: data.title
  });
};
ContactUsToolBar.fragment = fragment;
ContactUsToolBar.displayName = "ContactUsToolBar";

// ../internal/src/components/egds-button/egds-button.tsx
import React5 from "react";
import { EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { gql as gql4 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-graphic/egds-icon.tsx
import React3 from "react";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { gql as gql2 } from "@shared-ui/apollo-client-wrapper";
var __EGDSIconFragment = gql2`
  fragment EGDSIconFragment on Icon {
    description
    id
    size
    title
    theme
    spotLight
  }
`;
var mapSpotlight = spotlight => {
  if (!spotlight) {
    return void 0;
  }
  switch (spotlight) {
    case "STANDARD" /* STANDARD */:
      return "standard";
    case "POSITIVE" /* POSITIVE */:
      return "positive";
    case "WARNING" /* WARNING */:
      return "warning";
    case "INFO" /* INFO */:
      return "info";
    default:
      return void 0;
  }
};
var HelpCenterEGDSIcon = ({
  data,
  size
}) => {
  var _a, _b;
  const iconName = data ? data.id : "";
  const finalSize = size != null ? size : (data == null ? void 0 : data.size) && EGDSIconSize[data.size];
  const spotlight = data == null ? void 0 : data.spotLight;
  const title = (_a = data == null ? void 0 : data.title) != null ? _a : void 0;
  return /* @__PURE__ */React3.createElement(EGDSIcon, {
    id: iconName,
    name: iconName,
    size: finalSize,
    title,
    theme: (_b = data == null ? void 0 : data.theme) != null ? _b : void 0,
    spotlight: mapSpotlight(spotlight)
  });
};
HelpCenterEGDSIcon.displayName = "HelpCenterEGDSIcon";
HelpCenterEGDSIcon.fragment = __EGDSIconFragment;

// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React4 from "react";
import { gql as gql3 } from "@shared-ui/apollo-client-wrapper";
var __EGDSGraphicFragment = gql3`
  fragment EGDSGraphicFragment on UIGraphic {
    ... on Icon {
      ...EGDSIconFragment
    }
  }

  ${HelpCenterEGDSIcon.fragment}
`;
var EGDSGraphic = ({
  data
}) => {
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;

// ../internal/src/components/egds-button/egds-button.tsx
var __fragment = gql4`
  fragment EGDSButtonFragment on EGDSButton {
    primary
    disabled
    icon {
      ...EGDSIconFragment
    }
    accessibility
  }
  ${HelpCenterEGDSIcon.fragment}
`;
var HelpCenterEGDSButton = _a => {
  var _b = _a,
    {
      data,
      onClickHandler,
      isDisabled,
      type,
      iconPosition = "LEADING" /* LEADING */
    } = _b,
    otherProps = __objRest(_b, ["data", "onClickHandler", "isDisabled", "type", "iconPosition"]);
  const {
    primary,
    disabled,
    accessibility,
    __typename,
    icon
  } = data;
  const buttonProps = {
    disabled: disabled || isDisabled,
    title: accessibility,
    type,
    onClick: onClickHandler
  };
  switch (__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React5.createElement(EGDSPrimaryButton, __spreadValues(__spreadValues({}, buttonProps), otherProps), icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React5.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React5.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    case "UISecondaryButton":
      return /* @__PURE__ */React5.createElement(EGDSSecondaryButton, __spreadValues(__spreadValues({}, buttonProps), otherProps), icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React5.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React5.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    case "UITertiaryButton":
      return /* @__PURE__ */React5.createElement(EGDSTertiaryButton, __spreadValues(__spreadValues({}, buttonProps), otherProps), icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React5.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React5.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    default:
      return null;
  }
};
HelpCenterEGDSButton.displayName = "HelpCenterEGDSButton";
HelpCenterEGDSButton.fragment = __fragment;

// ../internal/src/components/egds-text-input/egds-text-input.tsx
import React6 from "react";
import { EGDSEmailInput, EGDSTextInput } from "@egds/react-core/input";
import { gql as gql5 } from "@shared-ui/apollo-client-wrapper";
var fragment2 = gql5`
  fragment EGDSTextInputFragment on EGDSInputField {
    label
    readOnly
    required
    leftIcon {
      ...EGDSIconFragment
    }
    rightIcon {
      ...EGDSIconFragment
    }
    validations {
      errorMessage
      ... on EGDSRegexInputValidation {
        pattern
      }
    }
  }
  ${HelpCenterEGDSIcon.fragment}
`;
var HelpCenterEGDSTextInput = _a => {
  var _b = _a,
    {
      data,
      value,
      onChange,
      invalid,
      pattern,
      disabled,
      onKeyPress
    } = _b,
    otherProps = __objRest(_b, ["data", "value", "onChange", "invalid", "pattern", "disabled", "onKeyPress"]);
  const {
    label,
    readOnly,
    required
  } = data;
  switch (data.__typename) {
    case "EGDSTextInputField":
      return /* @__PURE__ */React6.createElement(EGDSTextInput, __spreadProps(__spreadValues({}, otherProps), {
        label: label != null ? label : "",
        "aria-label": label != null ? label : "",
        readOnly: disabled || readOnly,
        required: required != null ? required : false,
        value,
        onChange,
        invalid,
        pattern,
        onKeyPress
      }));
    case "EGDSEmailInputField":
      return /* @__PURE__ */React6.createElement(EGDSEmailInput, __spreadProps(__spreadValues({}, otherProps), {
        label: label != null ? label : "",
        readOnly: disabled || readOnly,
        required: required != null ? required : false,
        value,
        onChange,
        invalid,
        pattern,
        onKeyPress
      }));
    default:
      return null;
  }
};
HelpCenterEGDSTextInput.fragment = fragment2;
HelpCenterEGDSTextInput.displayName = "HelpCenterEGDSTextInput";

// ../internal/src/components/egds-text-input/egds-text-area-input.tsx
import React7 from "react";
import { EGDSTextArea } from "@egds/react-core/input";
import { gql as gql6 } from "@shared-ui/apollo-client-wrapper";
var fragment3 = gql6`
  fragment EGDSTextAreaInputFragment on EGDSTextAreaInputField {
    label
    readOnly
    required
  }
`;
var EGDSTextAreaInput = ({
  data,
  value,
  minRows,
  maxRows,
  onChange,
  disabled
}) => {
  const {
    label,
    readOnly,
    required
  } = data;
  return /* @__PURE__ */React7.createElement(EGDSTextArea, {
    label,
    readOnly: disabled || readOnly,
    required: required != null ? required : false,
    value,
    minRows,
    maxRows,
    onChange
  });
};
EGDSTextAreaInput.fragment = fragment3;
EGDSTextAreaInput.displayName = "EGDSTextAreaInput";

// ../internal/src/components/sheet/sheet-loader.tsx
import React8 from "react";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLoader } from "@egds/react-core/loader";
var SheetLoader = props => {
  return /* @__PURE__ */React8.createElement(EGDSLayoutFlex, {
    justifyContent: "center",
    blockSize: "full_size"
  }, /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem, {
    alignSelf: "center"
  }, /* @__PURE__ */React8.createElement(EGDSLoader, __spreadValues({}, props))));
};

// src/utils/logger-events.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var EVENTS = {
  INTENT_BUTTON_CLICK: new SystemEvent(SystemEventLevel.INFO, "INTENT_BUTTON_CLICK_INFO"),
  SENDING_MESSAGE: new SystemEvent(SystemEventLevel.INFO, "SENDING_MESSAGE"),
  VAC_NOT_INITIALISED: new SystemEvent(SystemEventLevel.ERROR, "VAC_NOT_INITIALISED"),
  CONTACT_US_DATA_LOADING_ERROR: new SystemEvent(SystemEventLevel.ERROR, "CONTACT_US_DATA_LOADING_ERROR")
};

// src/components/contact-us/__private/__fragments/back-button/back-button.tsx
import React9 from "react";
import { EGDSLink } from "@egds/react-core/link";
var BackButton = ({
  data,
  onClickHandler
}) => {
  const {
    back
  } = data;
  return /* @__PURE__ */React9.createElement(EGDSLink, {
    key: "back",
    onClick: onClickHandler
  }, /* @__PURE__ */React9.createElement("button", {
    type: "button",
    key: "button"
  }, back));
};
BackButton.displayName = "BackButton";

// src/components/contact-us/__private/__fragments/contact-us-send-email-view.tsx
import React12, { useCallback, useEffect, useState } from "react";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { gql as gql9, useMutation } from "@shared-ui/apollo-client-wrapper";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useLoggerEvents } from "@shared-ui/logger-context";

// src/components/contact-us/__private/__fragments/send-email-response/contact-us-send-email-failed.tsx
import React10 from "react";
import { EGDSBanner } from "@egds/react-core/banner";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText } from "@egds/react-core/text";
import { gql as gql7 } from "@shared-ui/apollo-client-wrapper";
var __fragment2 = gql7`
  fragment ContactUsSendEmailFailedFragment on ContactUsSendEmailFailed {
    title
    message
    icon {
      id
    }
    button {
      ...EGDSButtonFragment
    }
  }

  ${HelpCenterEGDSButton.fragment}
`;
var CARD_SPACING = {
  blockstart: "four"
};
var BUTTON_SPACING = {
  blockstart: "four"
};
var ContactUsSendEmailFailed = ({
  data,
  onClick,
  submitDisabled
}) => {
  const {
    title,
    message,
    icon,
    button
  } = data;
  return /* @__PURE__ */React10.createElement(React10.Fragment, null, /* @__PURE__ */React10.createElement(EGDSSpacing, {
    margin: CARD_SPACING
  }, /* @__PURE__ */React10.createElement("div", null, /* @__PURE__ */React10.createElement(EGDSBanner, {
    theme: "error"
  }, /* @__PURE__ */React10.createElement(EGDSLayoutFlex2, {
    alignItems: "center",
    space: "two"
  }, /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React10.createElement(EGDSIcon2, {
    name: icon.id,
    spotlight: {
      theme: "standard"
    }
  })), /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React10.createElement("div", null, /* @__PURE__ */React10.createElement(EGDSHeading, {
    size: 7,
    tag: "h4"
  }, title), /* @__PURE__ */React10.createElement(EGDSText, {
    size: 300
  }, message))))))), /* @__PURE__ */React10.createElement(EGDSSpacing, {
    margin: BUTTON_SPACING
  }, /* @__PURE__ */React10.createElement("div", null, /* @__PURE__ */React10.createElement(HelpCenterEGDSButton, {
    data: button,
    onClickHandler: onClick,
    isDisabled: submitDisabled
  }))));
};
ContactUsSendEmailFailed.fragment = __fragment2;
ContactUsSendEmailFailed.displayName = "ContactUsSendEmailFailed";

// src/components/contact-us/__private/__fragments/send-email-response/contact-us-send-email-success.tsx
import React11 from "react";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon3 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { gql as gql8 } from "@shared-ui/apollo-client-wrapper";
var __fragment3 = gql8`
  fragment ContactUsSendEmailSuccessFragment on ContactUsSendEmailSuccess {
    title
    message
    icon {
      id
    }
    button {
      ...EGDSButtonFragment
    }
  }

  ${HelpCenterEGDSButton.fragment}
`;
var BUTTON_SPACING2 = {
  blockstart: "four"
};
var ContactUsSendEmailSuccess = ({
  data,
  onClick
}) => {
  const {
    title,
    message,
    icon,
    button
  } = data;
  return /* @__PURE__ */React11.createElement(React11.Fragment, null, /* @__PURE__ */React11.createElement(EGDSCard, {
    padded: true
  }, /* @__PURE__ */React11.createElement(EGDSLayoutFlex3, {
    alignItems: "center",
    space: "two"
  }, /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React11.createElement("div", null, /* @__PURE__ */React11.createElement(EGDSIcon3, {
    name: icon.id,
    spotlight: "positive"
  }))), /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React11.createElement("div", null, /* @__PURE__ */React11.createElement(EGDSHeading2, {
    size: 7,
    tag: "h4"
  }, title), /* @__PURE__ */React11.createElement(EGDSText2, {
    size: 300
  }, message))))), /* @__PURE__ */React11.createElement(EGDSSpacing2, {
    margin: BUTTON_SPACING2
  }, /* @__PURE__ */React11.createElement("div", null, /* @__PURE__ */React11.createElement(HelpCenterEGDSButton, {
    data: button,
    onClickHandler: onClick
  }))));
};
ContactUsSendEmailSuccess.fragment = __fragment3;
ContactUsSendEmailSuccess.displayName = "ContactUsSendEmailSuccess";

// src/components/contact-us/__private/__fragments/contact-us-send-email-view.tsx
var CONTACT_US_DATA_LOADING_ERROR_MESSAGE = "Error while sending an email";
var SendEmailMutation = gql9`
  mutation sendContactUsEmail(
    $context: ContextInput!
    $customerName: String!
    $customerEmail: String!
    $details: String!
    $intent: String!
    $product: String!
  ) {
    contactUsOptions(context: $context) {
      sendContactUsEmail(
        sendEmailRequest: { customerName: $customerName, customerEmail: $customerEmail, details: $details, intent: $intent, product: $product }
      ) {
        ...ContactUsSendEmailSuccessFragment
        ...ContactUsSendEmailFailedFragment
      }
    }
  }

  ${ContactUsSendEmailSuccess.fragment}
  ${ContactUsSendEmailFailed.fragment}
`;
var SEND_BUTTON_SPACING = {
  blockstart: "four"
};
var ContactUsSendEmailView = props => {
  var _a;
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const {
    onClose,
    sendButton,
    request,
    disableForm,
    isEmailAddressValid
  } = props;
  const {
    context
  } = useBexApi();
  const logEvents = useLoggerEvents(EVENTS);
  const submitDisabled = isEmailAddressValid || isButtonDisabled || request.customerEmail === "" || request.customerName === "" || request.details === "";
  const [sendEmail, {
    data,
    error
  }] = useMutation(SendEmailMutation);
  useEffect(() => {
    var _a2;
    setButtonDisabled(false);
    if (((_a2 = data == null ? void 0 : data.contactUsOptions) == null ? void 0 : _a2.sendContactUsEmail.__typename) === "ContactUsSendEmailFailed") {
      disableForm(false);
    }
  }, [data]);
  const clickSendEmail = useCallback(() => {
    setButtonDisabled(true);
    disableForm(true);
    sendEmail({
      variables: __spreadValues({
        context
      }, request)
    });
  }, [sendEmail, context, request]);
  if (error) {
    logEvents.CONTACT_US_DATA_LOADING_ERROR.log({
      message: `${CONTACT_US_DATA_LOADING_ERROR_MESSAGE}: ${error}`
    });
    return null;
  }
  const responseView = (_a = data == null ? void 0 : data.contactUsOptions) == null ? void 0 : _a.sendContactUsEmail;
  switch (responseView == null ? void 0 : responseView.__typename) {
    case "ContactUsSendEmailSuccess":
      return /* @__PURE__ */React12.createElement(ContactUsSendEmailSuccess, {
        data: responseView,
        onClick: onClose
      });
    case "ContactUsSendEmailFailed":
      return /* @__PURE__ */React12.createElement(ContactUsSendEmailFailed, {
        data: responseView,
        onClick: clickSendEmail,
        submitDisabled
      });
    default:
      return /* @__PURE__ */React12.createElement(EGDSSpacing3, {
        margin: SEND_BUTTON_SPACING
      }, /* @__PURE__ */React12.createElement("div", null, /* @__PURE__ */React12.createElement(HelpCenterEGDSButton, {
        data: sendButton,
        onClickHandler: clickSendEmail,
        isDisabled: submitDisabled
      })));
  }
};
ContactUsSendEmailView.displayName = "ContactUsSendEmailView";

// src/components/contact-us/__private/__fragments/heading.tsx
import React13 from "react";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3, EGDSSubheading } from "@egds/react-core/text";
var HEADING_SPACING = {
  blockstart: "four"
};
var SUB_HEADING_SPACING = {
  blockstart: "six"
};
var Heading = props => {
  const {
    heading,
    subheading
  } = props;
  return /* @__PURE__ */React13.createElement(React13.Fragment, null, /* @__PURE__ */React13.createElement(EGDSSpacing4, {
    margin: HEADING_SPACING
  }, /* @__PURE__ */React13.createElement(EGDSHeading3, {
    tag: "h2",
    size: 3
  }, heading)), /* @__PURE__ */React13.createElement(EGDSSpacing4, {
    margin: SUB_HEADING_SPACING
  }, /* @__PURE__ */React13.createElement("div", null, /* @__PURE__ */React13.createElement(EGDSSubheading, {
    tag: "h3"
  }, subheading))));
};

// src/components/contact-us/__private/__fragments/contact-us-email-us-form-view.tsx
var CONTACT_US_DATA_LOADING_ERROR_MESSAGE2 = "Error while loading email us form";
var EMAIL_FORM_SPACING = {
  blockstart: "four"
};
var __Query = gql10`
  query EmailUsForm($context: ContextInput!) {
    contactUsOptions(context: $context) {
      contactUsEmailFormView(optionType: SEND_EMAIL_AGENT) {
        ... on ContactUsEmailSheet {
          back
          toolBar {
            ...ContactUsToolBarFragment
          }
          customerName {
            ...EGDSTextInputFragment
          }
          customerEmail {
            ...EGDSTextInputFragment
          }
          heading
          subheading
          details {
            ...EGDSTextAreaInputFragment
          }
          send {
            ...EGDSButtonFragment
          }
        }
      }
    }
  }

  ${ContactUsToolBar.fragment}
  ${HelpCenterEGDSTextInput.fragment}
  ${EGDSTextAreaInput.fragment}
  ${HelpCenterEGDSButton.fragment}
`;
var ContactUsEmailUsFormView = props => {
  var _a;
  const {
    onClose,
    onClickBack,
    product,
    intent,
    skipSsr
  } = props;
  const {
    context
  } = useBexApi2();
  const logEvents = useLoggerEvents2(EVENTS);
  const emailAddressValidationInfo = {
    validationPattern: "",
    errorMessage: ""
  };
  const [customerName, setCustomerName] = useState2("");
  const [customerEmail, setCustomerEmail] = useState2({
    inputValue: "",
    errorMessage: "",
    isEmailValid: false
  });
  const [details, setDetails] = useState2("");
  const [formDisabled, setFormDisabled] = useState2(false);
  const validator = (value, re) => re && value.match(new RegExp(re));
  const onChangeCustomerName = event => {
    setCustomerName(event.target.value);
  };
  const onChangeDetails = event => {
    setDetails(event.target.value);
  };
  const onChangeCustomerEmail = event => {
    const emailAddressValidationResult = !validator(event.target.value, emailAddressValidationInfo.validationPattern);
    setCustomerEmail({
      inputValue: event.target.value,
      errorMessage: emailAddressValidationResult ? emailAddressValidationInfo == null ? void 0 : emailAddressValidationInfo.errorMessage : "",
      isEmailValid: emailAddressValidationResult
    });
  };
  const variables = {
    context
  };
  const {
    data,
    error,
    loading
  } = useQuery(__Query, {
    context: {
      shouldLogPerformance: true
    },
    variables,
    ssr: !skipSsr
  });
  if (loading) {
    return /* @__PURE__ */React14.createElement(EGDSSheetContent, null, /* @__PURE__ */React14.createElement(SheetLoader, {
      isSmall: true
    }));
  }
  if (error || !data) {
    logEvents.CONTACT_US_DATA_LOADING_ERROR.log({
      message: `${CONTACT_US_DATA_LOADING_ERROR_MESSAGE2}: ${error}`
    });
    return null;
  }
  const {
    contactUsEmailFormView
  } = data.contactUsOptions;
  switch (contactUsEmailFormView.__typename) {
    case "ContactUsEmailSheet":
      {
        const {
          heading,
          subheading,
          toolBar,
          send
        } = contactUsEmailFormView;
        const emailAddressValidation = (_a = contactUsEmailFormView.customerEmail.validations) == null ? void 0 : _a[0];
        const validationPattern = (emailAddressValidation == null ? void 0 : emailAddressValidation.__typename) === "EGDSRegexInputValidation" ? emailAddressValidation.pattern : void 0;
        emailAddressValidationInfo.validationPattern = validationPattern;
        emailAddressValidationInfo.errorMessage = emailAddressValidation == null ? void 0 : emailAddressValidation.errorMessage;
        return /* @__PURE__ */React14.createElement(React14.Fragment, null, /* @__PURE__ */React14.createElement(ContactUsToolBar, {
          close: onClose,
          data: toolBar
        }), /* @__PURE__ */React14.createElement(EGDSSheetContent, null, /* @__PURE__ */React14.createElement(BackButton, {
          data: contactUsEmailFormView,
          onClickHandler: onClickBack
        }), /* @__PURE__ */React14.createElement(Heading, {
          heading,
          subheading
        }), /* @__PURE__ */React14.createElement(EGDSForm, {
          hasRequiredFieldIndicator: true
        }, /* @__PURE__ */React14.createElement(EGDSSpacing5, {
          margin: EMAIL_FORM_SPACING
        }, /* @__PURE__ */React14.createElement(EGDSLayoutFlex4, {
          space: "four",
          direction: "column"
        }, /* @__PURE__ */React14.createElement(HelpCenterEGDSTextInput, {
          data: contactUsEmailFormView.customerName,
          value: customerName,
          onChange: onChangeCustomerName,
          disabled: formDisabled
        }), /* @__PURE__ */React14.createElement(HelpCenterEGDSTextInput, {
          data: contactUsEmailFormView.customerEmail,
          value: customerEmail.inputValue,
          invalid: customerEmail.errorMessage,
          onChange: onChangeCustomerEmail,
          disabled: formDisabled
        }), /* @__PURE__ */React14.createElement(EGDSTextAreaInput, {
          data: contactUsEmailFormView.details,
          value: details,
          onChange: onChangeDetails,
          minRows: 3,
          disabled: formDisabled
        })))), /* @__PURE__ */React14.createElement(ContactUsSendEmailView, {
          sendButton: send,
          request: {
            customerName,
            customerEmail: customerEmail.inputValue,
            product,
            intent,
            details
          },
          onClose,
          disableForm: setFormDisabled,
          isEmailAddressValid: customerEmail.isEmailValid
        }), /* @__PURE__ */React14.createElement(EGDSSpacingHr, {
          blockMargin: "six"
        })));
      }
    default:
      return null;
  }
};
ContactUsEmailUsFormView.displayName = "ContactUsEmailUsFormView";

// src/components/contact-us/__private/__fragments/contact-us-options-view.tsx
import React17 from "react";
import { EGDSActionList } from "@egds/react-core/action-list-item";
import { EGDSSheetContent as EGDSSheetContent3 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing7, EGDSSpacingHr as EGDSSpacingHr3 } from "@egds/react-core/spacing";
import { gql as gql13, useQuery as useQuery2 } from "@shared-ui/apollo-client-wrapper";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents4 } from "@shared-ui/logger-context";

// src/components/contact-us/__private/__fragments/contact-us-error-view.tsx
import React15 from "react";
import { EGDSBanner as EGDSBanner2 } from "@egds/react-core/banner";
import { EGDSIcon as EGDSIcon4 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSSheetContent as EGDSSheetContent2 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing6, EGDSSpacingHr as EGDSSpacingHr2 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading4, EGDSText as EGDSText3 } from "@egds/react-core/text";
import { gql as gql11 } from "@shared-ui/apollo-client-wrapper";
var ERROR_VIEW_SPACING = {
  blockstart: "four"
};
var fragment4 = gql11`
  fragment ContactUsErrorViewFragment on ContactUsErrorView {
    heading
    subHeadingText: subheading
    icon {
      id
    }
    errorTitle
    errorMessage
    toolBar {
      ...ContactUsToolBarFragment
    }
  }
`;
var ContactUsErrorView = props => {
  var _a;
  const {
    data,
    onClose
  } = props;
  return /* @__PURE__ */React15.createElement(React15.Fragment, null, /* @__PURE__ */React15.createElement(ContactUsToolBar, {
    close: onClose,
    data: data.toolBar
  }), /* @__PURE__ */React15.createElement(EGDSSheetContent2, null, /* @__PURE__ */React15.createElement(Heading, {
    heading: data.heading,
    subheading: (_a = data.subHeadingText) != null ? _a : ""
  }), /* @__PURE__ */React15.createElement(EGDSSpacing6, {
    margin: ERROR_VIEW_SPACING
  }, /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(EGDSBanner2, {
    theme: "error"
  }, /* @__PURE__ */React15.createElement(EGDSLayoutFlex5, {
    alignItems: "center",
    space: "two"
  }, /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(EGDSIcon4, {
    name: data.icon.id,
    spotlight: {
      theme: "standard",
      background: false
    }
  }))), /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(EGDSHeading4, {
    size: 7,
    tag: "h4"
  }, data.errorTitle), /* @__PURE__ */React15.createElement(EGDSText3, null, data.errorMessage))))))), /* @__PURE__ */React15.createElement(EGDSSpacingHr2, {
    blockMargin: "six"
  })));
};
ContactUsErrorView.fragment = fragment4;
ContactUsErrorView.displayName = "ContactUsErrorView";

// src/components/contact-us/__private/__fragments/contact-us-option.tsx
import React16 from "react";
import { EGDSActionListItem, EGDSActionListItemLink } from "@egds/react-core/action-list-item";
import { EGDSIcon as EGDSIcon5 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
import { gql as gql12 } from "@shared-ui/apollo-client-wrapper";
import { useSignalPublisher } from "@shared-ui/core-signal-manager/context";
import { useExperiment } from "@shared-ui/experiment-context";
import { useLoggerEvents as useLoggerEvents3 } from "@shared-ui/logger-context";
import { useVirtualAgentContext } from "@shared-ui/retail-help-center-util";
import { VacCreateConversationSignal, VirtualAgentControlMessageType } from "@shared-ui/retail-signals-virtual-agent";
import { ViewMedium, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
var fragment5 = gql12`
  fragment ContactUsOptionFragment on ContactUsOption {
    optionLabel
    leftIcon {
      id
    }
    rightIcon {
      id
    }
    waitTime
    option
  }
`;
var ContactUsOption = props => {
  const {
    data,
    onNavigate,
    onClose
  } = props;
  const logEvents = useLoggerEvents3(EVENTS);
  const {
    controller
  } = useVirtualAgentContext();
  const {
    publish
  } = useSignalPublisher();
  const isSharedUIHelpCenter = useExperiment("Shared_UI_VAC_Web_HelpCenter").exposure.bucket === 1;
  const initiateVacMessage = async () => {
    logEvents.INTENT_BUTTON_CLICK.log({
      message: `calling sendMessage for ${data.optionLabel}`
    });
    onClose();
    if (!isSharedUIHelpCenter) {
      controller.sendMessage({
        messageType: "POSTBACK",
        text: data.optionLabel,
        intent: "AGENT_CONNECT_REQUEST"
      });
    } else {
      const message = {
        conversationAttributes: [{
          key: "launchPoint",
          value: "FAB"
        }, {
          key: "pageName",
          value: "Help Articles"
        }, {
          key: "conversationType",
          value: "main"
        }],
        intentData: {
          messageType: VirtualAgentControlMessageType.POSTBACK,
          intent: "AGENT_CONNECT_REQUEST",
          text: data.optionLabel
        },
        silent: false
      };
      const signal = new VacCreateConversationSignal("VAC_IBM_CREATE_CONVERSATION", message);
      publish(signal);
    }
  };
  const renderView = React16.useCallback(() => {
    switch (data.option) {
      case "CHAT_WITH_AGENT":
      case "CHAT_BACK_WITH_AGENT":
      case "CALL_BACK_WITH_AGENT":
        return /* @__PURE__ */React16.createElement(Viewport2, null, /* @__PURE__ */React16.createElement(ViewSmall2, null, /* @__PURE__ */React16.createElement(EGDSActionListItemLink, null, /* @__PURE__ */React16.createElement("button", {
          type: "button",
          onClick: initiateVacMessage
        }, data.optionLabel))), /* @__PURE__ */React16.createElement(ViewMedium, null, /* @__PURE__ */React16.createElement(EGDSActionListItemLink, null, /* @__PURE__ */React16.createElement("button", {
          type: "button",
          onClick: initiateVacMessage
        }, data.optionLabel))));
      default:
        return /* @__PURE__ */React16.createElement(EGDSActionListItemLink, null, /* @__PURE__ */React16.createElement("button", {
          type: "button",
          onClick: () => onNavigate(data.option)
        }, data.optionLabel));
    }
  }, [data.option, data.optionLabel, logEvents, onNavigate]);
  return /* @__PURE__ */React16.createElement(EGDSActionListItem, {
    key: data.optionLabel
  }, renderView(), /* @__PURE__ */React16.createElement(EGDSLayoutFlex6, {
    space: "three"
  }, /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem5, {
    shrink: 0,
    alignSelf: "center"
  }, /* @__PURE__ */React16.createElement(EGDSIcon5, {
    name: data.leftIcon.id
  })), /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem5, {
    grow: 1
  }, /* @__PURE__ */React16.createElement("section", null, /* @__PURE__ */React16.createElement(EGDSText4, {
    size: 400,
    weight: "bold"
  }, data.optionLabel), /* @__PURE__ */React16.createElement(EGDSText4, {
    size: 200,
    theme: "standard"
  }, data.waitTime))), /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem5, {
    alignSelf: "center"
  }, /* @__PURE__ */React16.createElement(EGDSIcon5, {
    name: data.rightIcon.id
  }))));
};
ContactUsOption.fragment = fragment5;
ContactUsOption.displayName = "ContactUsOption";

// src/components/contact-us/__private/__fragments/contact-us-options-view.tsx
var CONTACT_US_DATA_LOADING_ERROR_MESSAGE3 = "Error while loading contact options";
var ACTION_LIST_SPACING = {
  blockstart: "four"
};
var __Query2 = gql13`
  query ContactUsOptions($context: ContextInput!, $phoneNumber: String!, $itineraryNumber: String!, $category: String!, $intent: String!) {
    contactUsOptions(context: $context) {
      contactUsOptionsView(searchFormInput: { phoneNumber: $phoneNumber, itineraryNumber: $itineraryNumber, category: $category, intent: $intent }) {
        ... on ContactOptionsSheet {
          heading
          subheading
          options {
            ...ContactUsOptionFragment
          }
          toolBar {
            ...ContactUsToolBarFragment
          }
        }
        ...ContactUsErrorViewFragment
      }
    }
  }
  ${ContactUsToolBar.fragment}
  ${ContactUsOption.fragment}
  ${ContactUsErrorView.fragment}
`;
var ContactUsOptionsView = props => {
  const {
    onClose,
    skipSsr,
    inputs,
    onNavigate
  } = props;
  const {
    context
  } = useBexApi3();
  const logEvents = useLoggerEvents4(EVENTS);
  const variables = __spreadProps(__spreadValues({}, inputs), {
    context
  });
  const {
    data,
    error,
    loading
  } = useQuery2(__Query2, {
    context: {
      shouldLogPerformance: true
    },
    variables,
    ssr: !skipSsr
  });
  if (loading) {
    return /* @__PURE__ */React17.createElement(EGDSSheetContent3, null, /* @__PURE__ */React17.createElement(SheetLoader, {
      isSmall: true
    }));
  }
  if (error || !data) {
    logEvents.CONTACT_US_DATA_LOADING_ERROR.log({
      message: `${CONTACT_US_DATA_LOADING_ERROR_MESSAGE3}: ${error}`
    });
    return null;
  }
  const {
    contactUsOptionsView
  } = data.contactUsOptions;
  switch (contactUsOptionsView.__typename) {
    case "ContactOptionsSheet":
      {
        const {
          options,
          heading,
          subheading,
          toolBar
        } = contactUsOptionsView;
        return /* @__PURE__ */React17.createElement(React17.Fragment, null, /* @__PURE__ */React17.createElement(ContactUsToolBar, {
          close: onClose,
          data: toolBar
        }), /* @__PURE__ */React17.createElement(EGDSSheetContent3, null, /* @__PURE__ */React17.createElement(Heading, {
          heading,
          subheading
        }), /* @__PURE__ */React17.createElement(EGDSSpacing7, {
          margin: ACTION_LIST_SPACING
        }, /* @__PURE__ */React17.createElement(EGDSActionList, null, options.map(option => /* @__PURE__ */React17.createElement(ContactUsOption, {
          key: option.optionLabel,
          onNavigate,
          data: option,
          onClose
        })))), /* @__PURE__ */React17.createElement(EGDSSpacingHr3, {
          blockMargin: "six"
        })));
      }
    case "ContactUsErrorView":
      {
        return /* @__PURE__ */React17.createElement(ContactUsErrorView, {
          onClose,
          data: contactUsOptionsView
        });
      }
  }
};
ContactUsOptionsView.displayName = "ContactUsOptionsView";

// src/components/contact-us/__private/__fragments/contact-us-sheet-view.tsx
import React20, { useCallback as useCallback2, useEffect as useEffect3, useState as useState3 } from "react";
import { EGDSForm as EGDSForm2 } from "@egds/react-core/form";
import { EGDSLayoutFlex as EGDSLayoutFlex7 } from "@egds/react-core/layout-flex";
import { EGDSSheetContent as EGDSSheetContent4 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing8, EGDSSpacingHr as EGDSSpacingHr4 } from "@egds/react-core/spacing";
import { gql as gql16, useQuery as useQuery3 } from "@shared-ui/apollo-client-wrapper";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents5 } from "@shared-ui/logger-context";

// ../internal/src/components/egds-select/egds-select.tsx
import React19 from "react";
import { EGDSSelect } from "@egds/react-core/input";
import { gql as gql15 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-select/egds-basic-option.tsx
import React18 from "react";
import { gql as gql14 } from "@shared-ui/apollo-client-wrapper";
var __Fragment = gql14`
  fragment EGDSBasicOptionFragment on EGDSBasicOption {
    value
    selected
    label
  }
`;
var EGDSBasicOption = ({
  data
}) => {
  var _a;
  return /* @__PURE__ */React18.createElement("option", {
    key: data.value,
    value: data.value,
    "aria-selected": (_a = data.selected) != null ? _a : false
  }, data.label);
};
EGDSBasicOption.displayName = "EGDSBasicOption";
EGDSBasicOption.fragment = __Fragment;

// ../internal/src/components/egds-select/egds-select.tsx
var __Fragment2 = gql15`
  fragment EGDSSelectFragment on EGDSBasicSelect {
    options {
      ...EGDSBasicOptionFragment
    }
    label
    egdsElementId
    readOnly
  }
  ${EGDSBasicOption.fragment}
`;
var HelpCenterEGDSSelect = ({
  emptyState,
  value,
  onChange,
  data,
  required
}) => {
  const {
    label,
    egdsElementId,
    options,
    readOnly
  } = data;
  if (!egdsElementId || options.length === 0) {
    return null;
  }
  return /* @__PURE__ */React19.createElement(EGDSSelect, {
    readOnly,
    value,
    label,
    id: egdsElementId,
    onChange,
    emptyState,
    required
  }, options.map((optionItem, index) => optionItem.__typename === "EGDSBasicOption" && /* @__PURE__ */React19.createElement(EGDSBasicOption, {
    key: `option-${index}`,
    data: optionItem
  })));
};
HelpCenterEGDSSelect.displayName = "HelpCenterEGDSSelect";
HelpCenterEGDSSelect.fragment = __Fragment2;

// src/components/contact-us/__private/__fragments/contact-us-sheet-view.tsx
var CONTACT_US_DATA_LOADING_ERROR_MESSAGE4 = "Error while loading contact form details";
var CUSTOMER_FORM_SPACING = {
  blockstart: "four"
};
var SUBMIT_BUTTON_SPACING = {
  blockstart: "four"
};
var __Query3 = gql16`
  query ContactUsFormDetails($context: ContextInput!, $articleProduct: String, $articleIntent: String) {
    contactUsOptions(context: $context) {
      contactUsSheetViewWithPayload(articleProduct: $articleProduct, articleIntent: $articleIntent) {
        ... on ContactUsSheet {
          toolBar {
            ...ContactUsToolBarFragment
          }
          heading
          subheading
          customerFormContent {
            phoneNumber {
              ...EGDSTextInputFragment
            }
            itineraryNumber {
              ...EGDSTextInputFragment
            }
            categorySelect {
              ...EGDSSelectFragment
            }
            intentSelect {
              ...EGDSSelectFragment
            }
          }
          seeContactUsOptions {
            ...EGDSButtonFragment
          }
        }
      }
    }
  }

  ${ContactUsToolBar.fragment}
  ${HelpCenterEGDSTextInput.fragment}
  ${HelpCenterEGDSButton.fragment}
  ${HelpCenterEGDSSelect.fragment}
`;
var ContactUsSheetView = props => {
  var _a, _b, _c, _d, _e, _f, _g;
  const {
    onClose,
    onSubmitDetails,
    formInputs,
    skipSsr
  } = props;
  const {
    context
  } = useBexApi4();
  const logEvents = useLoggerEvents5(EVENTS);
  const [phoneNumber, setPhoneNumber] = useState3({
    inputValue: (_a = formInputs == null ? void 0 : formInputs.phoneNumber) != null ? _a : "",
    errorMessage: ""
  });
  const [itineraryNumber, setItineraryNumber] = useState3({
    inputValue: (_b = formInputs == null ? void 0 : formInputs.itineraryNumber) != null ? _b : "",
    errorMessage: ""
  });
  const [category, setCategory] = useState3("");
  const [intent, setIntent] = useState3("");
  const clickSeeOptions = useCallback2(() => {
    onSubmitDetails({
      phoneNumber: phoneNumber.inputValue,
      itineraryNumber: itineraryNumber.inputValue,
      category,
      intent
    });
  }, [onSubmitDetails, phoneNumber, itineraryNumber, category, intent]);
  const variables = {
    context,
    articleProduct: (_c = formInputs == null ? void 0 : formInputs.category) != null ? _c : null,
    articleIntent: (_d = formInputs == null ? void 0 : formInputs.intent) != null ? _d : null
  };
  const {
    data,
    error,
    loading
  } = useQuery3(__Query3, {
    context: {
      shouldLogPerformance: true
    },
    variables,
    ssr: !skipSsr
  });
  const getSelectedOption = options => {
    const option = options.find(opt => opt.__typename === "EGDSBasicOption" && opt.selected);
    return (option == null ? void 0 : option.__typename) === "EGDSBasicOption" ? option.value : "";
  };
  useEffect3(() => {
    var _a2, _b2;
    if (((_b2 = (_a2 = data == null ? void 0 : data.contactUsOptions) == null ? void 0 : _a2.contactUsSheetViewWithPayload) == null ? void 0 : _b2.__typename) === "ContactUsSheet" && formInputs != null) {
      const {
        categorySelect,
        intentSelect
      } = data.contactUsOptions.contactUsSheetViewWithPayload.customerFormContent;
      setCategory(getSelectedOption(categorySelect.options));
      setIntent(getSelectedOption(intentSelect.options));
    }
  }, [data, formInputs]);
  if (loading) {
    return /* @__PURE__ */React20.createElement(EGDSSheetContent4, null, /* @__PURE__ */React20.createElement(SheetLoader, {
      isSmall: true
    }));
  }
  if (error || !data) {
    logEvents.CONTACT_US_DATA_LOADING_ERROR.log({
      message: `${CONTACT_US_DATA_LOADING_ERROR_MESSAGE4}: ${error}`
    });
    return null;
  }
  const validator = (value, re) => re && value.match(new RegExp(re));
  const onChangePhoneNumber = errorMessage => event => {
    setPhoneNumber({
      inputValue: event.target.value,
      errorMessage: event.target.validationMessage && errorMessage
    });
  };
  const onChangeItineraryNumber = errorMessage => event => {
    setItineraryNumber({
      inputValue: event.target.value,
      errorMessage: event.target.validationMessage && errorMessage
    });
  };
  const onChangeCategory = event => {
    setCategory(event.target.value);
  };
  const onChangeIntent = event => {
    setIntent(event.target.value);
  };
  const {
    contactUsSheetViewWithPayload
  } = data.contactUsOptions;
  switch (contactUsSheetViewWithPayload.__typename) {
    case "ContactUsSheet":
      {
        const {
          customerFormContent,
          heading,
          subheading,
          toolBar,
          seeContactUsOptions
        } = contactUsSheetViewWithPayload;
        const phoneNumberValidation = (_e = customerFormContent.phoneNumber.validations) == null ? void 0 : _e[0];
        const phoneNumberPattern = (phoneNumberValidation == null ? void 0 : phoneNumberValidation.__typename) === "EGDSRegexInputValidation" ? phoneNumberValidation.pattern : void 0;
        const phoneNumberErrorMessage = phoneNumberValidation == null ? void 0 : phoneNumberValidation.errorMessage;
        const itineraryNumberValidation = (_f = customerFormContent.itineraryNumber.validations) == null ? void 0 : _f[0];
        const itineraryNumberPattern = (itineraryNumberValidation == null ? void 0 : itineraryNumberValidation.__typename) === "EGDSRegexInputValidation" ? itineraryNumberValidation.pattern : void 0;
        const itineraryNumberErrorMessage = (_g = customerFormContent.itineraryNumber.validations) == null ? void 0 : _g[0].errorMessage;
        const submitDisabled = !validator(phoneNumber.inputValue, phoneNumberPattern) || customerFormContent.itineraryNumber.required && itineraryNumber.inputValue !== "" && !validator(itineraryNumber.inputValue, itineraryNumberPattern) || intent === "" || category === "";
        return /* @__PURE__ */React20.createElement(React20.Fragment, null, /* @__PURE__ */React20.createElement(ContactUsToolBar, {
          close: onClose,
          data: toolBar
        }), /* @__PURE__ */React20.createElement(EGDSSheetContent4, null, /* @__PURE__ */React20.createElement(Heading, {
          heading,
          subheading
        }), /* @__PURE__ */React20.createElement(EGDSForm2, {
          hasRequiredFieldIndicator: true,
          onSubmit: clickSeeOptions
        }, /* @__PURE__ */React20.createElement(EGDSSpacing8, {
          margin: CUSTOMER_FORM_SPACING
        }, /* @__PURE__ */React20.createElement(EGDSLayoutFlex7, {
          space: "four",
          direction: "column"
        }, /* @__PURE__ */React20.createElement("div", null, /* @__PURE__ */React20.createElement(HelpCenterEGDSTextInput, {
          data: customerFormContent.phoneNumber,
          value: phoneNumber.inputValue,
          onChange: onChangePhoneNumber(phoneNumberErrorMessage),
          invalid: phoneNumber.errorMessage,
          pattern: phoneNumberPattern
        })), /* @__PURE__ */React20.createElement("div", null, /* @__PURE__ */React20.createElement(HelpCenterEGDSTextInput, {
          data: customerFormContent.itineraryNumber,
          value: itineraryNumber.inputValue,
          onChange: onChangeItineraryNumber(itineraryNumberErrorMessage),
          invalid: itineraryNumber.errorMessage,
          pattern: itineraryNumberPattern
        })), /* @__PURE__ */React20.createElement("div", null, /* @__PURE__ */React20.createElement(HelpCenterEGDSSelect, {
          data: customerFormContent.categorySelect,
          value: category,
          emptyState: true,
          onChange: onChangeCategory,
          required: true
        })), /* @__PURE__ */React20.createElement("div", null, /* @__PURE__ */React20.createElement(HelpCenterEGDSSelect, {
          data: customerFormContent.intentSelect,
          value: intent,
          emptyState: true,
          onChange: onChangeIntent,
          required: true
        })))), /* @__PURE__ */React20.createElement(EGDSSpacing8, {
          margin: SUBMIT_BUTTON_SPACING
        }, /* @__PURE__ */React20.createElement("div", null, /* @__PURE__ */React20.createElement(HelpCenterEGDSButton, {
          data: seeContactUsOptions,
          type: "submit",
          isDisabled: submitDisabled
        })))), /* @__PURE__ */React20.createElement(EGDSSpacingHr4, {
          blockMargin: "six"
        })));
      }
    default:
      return null;
  }
};
ContactUsSheetView.displayName = "ContactUsSheetView";

// src/components/contact-us/__private/__fragments/speak-to-next-available-agent-view.tsx
import React22 from "react";
import { EGDSList } from "@egds/react-core/list";
import { EGDSSheetContent as EGDSSheetContent5 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { gql as gql18, useQuery as useQuery4 } from "@shared-ui/apollo-client-wrapper";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents6 } from "@shared-ui/logger-context";

// src/components/contact-us/__private/__fragments/phone-number-data.tsx
import React21, { useMemo } from "react";
import { EGDSPrimaryButton as EGDSPrimaryButton2 } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSListItem } from "@egds/react-core/list";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
import { gql as gql17 } from "@shared-ui/apollo-client-wrapper";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { ViewMedium as ViewMedium2, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
var __fragment4 = gql17`
  fragment PhoneNumberDataFragment on PhoneNumberData {
    call {
      ...EGDSButtonFragment
    }
    region
    phoneType
    phoneNumber
  }
  ${HelpCenterEGDSButton.fragment}
`;
var PhoneNumberData = props => {
  var _a, _b;
  const {
    data
  } = props;
  const callNumber = () => {
    window.open(`tel:${data.phoneNumber}`);
  };
  const label = useMemo(() => /* @__PURE__ */React21.createElement(EGDSText5, {
    size: 400,
    theme: "standard"
  }, data.region && /* @__PURE__ */React21.createElement(EGDSText5, {
    size: 400,
    theme: "standard",
    inline: "strong"
  }, data.region), data.phoneType), [data.region, data.phoneType]);
  return /* @__PURE__ */React21.createElement(Viewport3, null, /* @__PURE__ */React21.createElement(ViewSmall3, null, /* @__PURE__ */React21.createElement(EGDSListItem, {
    key: data.phoneType
  }, /* @__PURE__ */React21.createElement(EGDSLayoutFlex8, {
    space: "three",
    alignItems: "center"
  }, /* @__PURE__ */React21.createElement(EGDSLayoutFlexItem6, {
    grow: 1
  }, label), /* @__PURE__ */React21.createElement(EGDSLayoutFlexItem6, {
    shrink: 0
  }, /* @__PURE__ */React21.createElement(EGDSText5, {
    size: 400,
    weight: "bold"
  }, data.phoneNumber)), data.call && /* @__PURE__ */React21.createElement(EGDSLayoutFlexItem6, {
    shrink: 0
  }, /* @__PURE__ */React21.createElement(Experiment, {
    name: "ContactUsTelephoneLink"
  }, /* @__PURE__ */React21.createElement(ExperimentControl, null, /* @__PURE__ */React21.createElement(EGDSPrimaryButton2, {
    type: "button",
    onClick: callNumber,
    title: (_a = data.call.accessibility) != null ? _a : ""
  }, data.call.primary)), /* @__PURE__ */React21.createElement(ExperimentVariant, {
    bucket: 1
  }, /* @__PURE__ */React21.createElement(EGDSPrimaryButton2, {
    tag: "a",
    href: `tel:${data.phoneNumber}`,
    title: (_b = data.call.accessibility) != null ? _b : ""
  }, data.call.primary))))))), /* @__PURE__ */React21.createElement(ViewMedium2, null, /* @__PURE__ */React21.createElement(EGDSListItem, {
    key: data.phoneType
  }, /* @__PURE__ */React21.createElement(EGDSLayoutFlex8, {
    space: "two"
  }, /* @__PURE__ */React21.createElement(EGDSLayoutFlexItem6, {
    grow: 1,
    alignSelf: "start"
  }, label), /* @__PURE__ */React21.createElement(EGDSLayoutFlexItem6, {
    alignSelf: "end"
  }, /* @__PURE__ */React21.createElement(EGDSText5, {
    size: 400,
    weight: "bold"
  }, data.phoneNumber))))));
};
PhoneNumberData.fragment = __fragment4;
PhoneNumberData.displayName = "ContactUsPhoneNumber";

// src/components/contact-us/__private/__fragments/speak-to-next-available-agent-view.tsx
var SpeakNextAvailableAgentQuery = gql18`
  query SpeakNextAvailableAgentView($context: ContextInput!, $category: String!, $intent: String!) {
    contactUsOptions(context: $context) {
      speakNextAvailableAgentSheetView(speakNextAvailableSheetRequest: { category: $category, intent: $intent, optionType: CALL_TO_AGENT }) {
        ... on SpeakNextAvailableAgentSheet {
          back
          toolBar {
            ...ContactUsToolBarFragment
          }
          heading
          subheading
          phoneNumberList {
            ...PhoneNumberDataFragment
          }
        }
        ...ContactUsErrorViewFragment
      }
    }
  }
  ${ContactUsToolBar.fragment}
  ${PhoneNumberData.fragment}
  ${ContactUsErrorView.fragment}
`;
var CONTACT_US_DATA_LOADING_ERROR_MESSAGE5 = "Error while loading available agent details";
var PHONE_NUMBER_LIST_SPACING = {
  block: "four"
};
var SpeakToNextAvailableAgentView = props => {
  const {
    onClose,
    onClickBackDetails,
    skipSsr,
    inputs
  } = props;
  const {
    context
  } = useBexApi5();
  const logEvents = useLoggerEvents6(EVENTS);
  const variables = __spreadProps(__spreadValues({}, inputs), {
    context
  });
  const {
    data,
    error,
    loading
  } = useQuery4(SpeakNextAvailableAgentQuery, {
    context: {
      shouldLogPerformance: true
    },
    variables,
    ssr: !skipSsr
  });
  if (loading) {
    return /* @__PURE__ */React22.createElement(EGDSSheetContent5, null, /* @__PURE__ */React22.createElement(SheetLoader, {
      isSmall: true
    }));
  }
  if (error || !data) {
    logEvents.CONTACT_US_DATA_LOADING_ERROR.log({
      message: `${CONTACT_US_DATA_LOADING_ERROR_MESSAGE5}: ${error}`
    });
    return null;
  }
  const {
    speakNextAvailableAgentSheetView
  } = data.contactUsOptions;
  switch (speakNextAvailableAgentSheetView.__typename) {
    case "SpeakNextAvailableAgentSheet":
      {
        const {
          toolBar,
          heading,
          subheading,
          phoneNumberList
        } = speakNextAvailableAgentSheetView;
        return /* @__PURE__ */React22.createElement(React22.Fragment, null, /* @__PURE__ */React22.createElement(ContactUsToolBar, {
          close: onClose,
          data: toolBar
        }), /* @__PURE__ */React22.createElement(EGDSSheetContent5, null, /* @__PURE__ */React22.createElement(BackButton, {
          data: speakNextAvailableAgentSheetView,
          onClickHandler: onClickBackDetails
        }), /* @__PURE__ */React22.createElement(Heading, {
          heading,
          subheading
        }), /* @__PURE__ */React22.createElement(EGDSSpacing9, {
          margin: PHONE_NUMBER_LIST_SPACING
        }, /* @__PURE__ */React22.createElement(EGDSList, {
          bullet: "no-bullet"
        }, phoneNumberList.map(phoneNumber => /* @__PURE__ */React22.createElement(PhoneNumberData, {
          key: phoneNumber.phoneType,
          data: phoneNumber
        }))))));
      }
    case "ContactUsErrorView":
      {
        return /* @__PURE__ */React22.createElement(ContactUsErrorView, {
          onClose,
          data: speakNextAvailableAgentSheetView
        });
      }
  }
};
SpeakToNextAvailableAgentView.displayName = "SpeakToNextAvailableAgentView";

// src/components/contact-us/contact-us-form.tsx
var ContactUsForm = props => {
  const {
    isVisible,
    onClose,
    formInputs
  } = props;
  const [view, setView] = useState4("ContactUsSheetView");
  const [customerFormContent, setCustomerFormContent] = useState4({
    phoneNumber: "",
    category: "",
    intent: "",
    itineraryNumber: ""
  });
  const onSubmitDetails = searchFormInput => {
    flushSync(() => {
      setCustomerFormContent(searchFormInput);
    });
    flushSync(() => {
      setView("ContactUsOptionsView");
    });
  };
  const onClickBack = () => {
    setView("ContactUsOptionsView");
  };
  const onNavigate = option => {
    switch (option) {
      case "SEND_EMAIL_AGENT":
        setView("ContactUsEmailUsFormView");
        break;
      case "CALL_TO_AGENT":
        setView("SpeakToNextAvailableAgentView");
        break;
    }
  };
  const renderView = useCallback3(() => {
    switch (view) {
      case "ContactUsSheetView":
        return /* @__PURE__ */React23.createElement(ContactUsSheetView, {
          inputs: {},
          formInputs,
          onClose,
          onSubmitDetails
        });
      case "ContactUsOptionsView":
        return /* @__PURE__ */React23.createElement(ContactUsOptionsView, {
          inputs: customerFormContent,
          onClose,
          onNavigate
        });
      case "SpeakToNextAvailableAgentView":
        return /* @__PURE__ */React23.createElement(SpeakToNextAvailableAgentView, {
          inputs: {
            category: customerFormContent.category,
            intent: customerFormContent.intent
          },
          onClose,
          onClickBackDetails: onClickBack
        });
      case "ContactUsEmailUsFormView":
        return /* @__PURE__ */React23.createElement(ContactUsEmailUsFormView, {
          inputs: {},
          product: customerFormContent.category,
          intent: customerFormContent.intent,
          onClose,
          onClickBack
        });
    }
  }, [view, onClose, formInputs, customerFormContent]);
  return /* @__PURE__ */React23.createElement(SheetViewPort, {
    isVisible,
    triggerRef: null
  }, /* @__PURE__ */React23.createElement("div", {
    "data-stid": "contactUs-dialog"
  }, renderView()));
};
ContactUsForm.displayName = "sharedui-ContactUsForm";
export { ContactUsForm };
//# sourceMappingURL=index.js.map